import { Range } from "immutable";

import {
  createAPI,
  createImageAPI,
  updateAPI,
  getAPI,
  getAllAPI,
  deleteAPI
} from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";
import { setField } from "../../common/lib/redux-fields/actions";

export const GET_ARTICLES = "GET_ARTICLES";
export const GET_ARTICLES_SUCCESS = "GET_ARTICLES_SUCCESS";
export const GET_ARTICLES_ERROR = "GET_ARTICLES_ERROR";
export const GET_ARTICLES_FINALLY = "GET_ARTICLES_FINALLY";

export const GET_ARTICLE = "GET_ARTICLE";
export const GET_ARTICLE_SUCCESS = "GET_ARTICLE_SUCCESS";
export const GET_ARTICLE_ERROR = "GET_ARTICLE_ERROR";
export const GET_ARTICLE_FINALLY = "GET_ARTICLE_FINALLY";

export const CREATE_ARTICLE = "CREATE_ARTICLE";
export const CREATE_ARTICLE_SUCCESS = "CREATE_ARTICLE_SUCCESS";
export const CREATE_ARTICLE_ERROR = "CREATE_ARTICLE_ERROR";
export const CREATE_ARTICLE_FINALLY = "CREATE_ARTICLE_FINALLY";

export const CREATE_ARTICLE_IMAGE = "CREATE_ARTICLE_IMAGE";
export const CREATE_ARTICLE_IMAGE_SUCCESS = "CREATE_ARTICLE_IMAGE_SUCCESS";
export const CREATE_ARTICLE_IMAGE_ERROR = "CREATE_ARTICLE_IMAGE_ERROR";
export const CREATE_ARTICLE_IMAGE_FINALLY = "CREATE_ARTICLE_IMAGE_FINALLY";

export const UPDATE_ARTICLE = "UPDATE_ARTICLE";
export const UPDATE_ARTICLE_SUCCESS = "UPDATE_ARTICLE_SUCCESS";
export const UPDATE_ARTICLE_ERROR = "UPDATE_ARTICLE_ERROR";
export const UPDATE_ARTICLE_FINALLY = "UPDATE_ARTICLE_FINALLY";

export const DELETE_ARTICLE = "DELETE_ARTICLE";
export const DELETE_ARTICLE_SUCCESS = "DELETE_ARTICLE_SUCCESS";
export const DELETE_ARTICLE_ERROR = "DELETE_ARTICLE_ERROR";
export const DELETE_ARTICLE_FINALLY = "DELETE_ARTICLE_FINALLY";

export const SET_ARTICLE_PAGE = "SET_ARTICLE_PAGE";
export const SET_ARTICLE_SORT = "SET_ARTICLE_SORT";

export const ARTICLE_CLEAR_ERROR = "ARTICLE_CLEAR_ERROR";
export const ARTICLE_CLEAR_FORM = "ARTICLE_CLEAR_FORM";
export const ARTICLE_CLEAR_FORM_PREVIEW = "ARTICLE_CLEAR_FORM_PREVIEW";

export const SET_DELETE_STATUS = "SET_DELETE_STATUS";

const validateCreate = (validate, msg, fields) =>
  validate(fields)
    .prop("title")
    .required(msg["app.validation.required"])
    .prop("author")
    .required(msg["app.validation.required"])
    .prop("isVisible")
    .required(msg["app.validation.required"])
    .prop("imageFileUid")
    .required(msg["app.validation.required"])
    .prop("imageAlt")
    .required(msg["app.validation.required"])
    .prop("seoDesc")
    .required(msg["app.validation.required"])
    .prop("shortDesc")
    .required(msg["app.validation.required"])
    .prop("mainDesc")
    .required(msg["app.validation.required"])
    .getErrors();

export const getAll = () => async (dispatch, getState, utils) => {
  const data = getState().article.meta.toJS();

  const action = GET_ARTICLES;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAllAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const get = data => async (dispatch, getState, utils) => {
  const action = GET_ARTICLE;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const create = data => async (dispatch, getState, utils) => {
  const action = CREATE_ARTICLE;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      createAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const createImage = data => async (dispatch, getState, utils) => {
  const action = CREATE_ARTICLE_IMAGE;

  let formData = new FormData();
  formData.append("file", data[0]);

  try {
    const { status, body } = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      createImageAPI,
      formData,
      null,
      body => {
        return new ValidationError(
          "imageFileUID",
          "Niepoprawny format lub wielkość pliku"
        );
      }
    );
    if (status === 200) {
      dispatch(setField(["articleForm", "imageFileUID"], body.uid));
    }
    return { status, body };
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const update = data => async (dispatch, getState, utils) => {
  const action = UPDATE_ARTICLE;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      updateAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const updateImage = data => async (dispatch, getState, utils) => {
  const action = UPDATE_ARTICLE;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      updateAPI,
      data,
      { authorized: true },
      () => new ValidationError("all", "")
    );
    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
  return null;
};

export const deleteOne = data => async (dispatch, getState, utils) => {
  const action = DELETE_ARTICLE;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      deleteAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );

    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const setPage = page => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_ARTICLE_PAGE,
    payload: { page }
  });

  dispatch(getAll());
};

export const setSort = (field, dir) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_ARTICLE_PAGE,
    payload: { page: 1 }
  });

  dispatch({
    type: SET_ARTICLE_SORT,
    payload: { field, dir }
  });

  dispatch(getAll());
};

export const clearError = field => ({
  type: ARTICLE_CLEAR_ERROR,
  payload: { field }
});

export const clearForm = () => ({
  type: ARTICLE_CLEAR_FORM
});

export const clearFormPreview = () => ({
  type: ARTICLE_CLEAR_FORM_PREVIEW
});

export const setDeleteStatus = status => ({
  type: SET_DELETE_STATUS,
  payload: { status }
});



// WEBPACK FOOTER //
// ./src/common/article/actions.js